import { render } from "./WCItemModifierQuantity.vue?vue&type=template&id=1fe2f250&scoped=true"
import script from "./WCItemModifierQuantity.vue?vue&type=script&lang=js"
export * from "./WCItemModifierQuantity.vue?vue&type=script&lang=js"

import "./WCItemModifierQuantity.vue?vue&type=style&index=0&id=1fe2f250&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2f250"]])

export default __exports__